export default __webpack_public_path__ + "static/media/exportExcel.36bc880f.png";